import * as API from '@/services/api';

export async function sendInteractionInvitationEmail(interactionInstanceToken, templateId) {
  const templateParam = templateId ? `?templateId=${templateId}` : '';
  const response = await API.get(`/api/instance/${interactionInstanceToken}/invite${templateParam}`);
  return response.data;
}

export async function updateInteractionAutosends(interactionInstanceToken, autosends) {
  const response = await API.patch(`/api/instance/${interactionInstanceToken}/auto_sends`, autosends);
  return response.data;
}
